module.exports = __webpack_public_path__ + "img/bg_tk_jl_con.1ed9e832.png";